import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';
import { DEFAULT_TIMEZONE } from '../common/constants';
import { EntityInfo, entityInfoApi } from '@/rtk/entityInfoApi';
import { Nullable } from '@/common/types';

export type EntityInfoState = {
  entityInfo: Nullable<EntityInfo>;
};

export const initialState: EntityInfoState = {
  entityInfo: null,
};

export const entityInfoSlice = createSlice({
  name: 'entityInfo',
  initialState,
  reducers: {
    resetEntityInfo: (state) => {
      state.entityInfo = initialState.entityInfo;
    },
  },
  extraReducers(builder) {
    builder.addMatcher(
      isAnyOf(entityInfoApi.endpoints.getEntityInfo.matchFulfilled),
      (state: EntityInfoState, action) => {
        state.entityInfo = action.payload;
      },
    );
  },
});

export const { resetEntityInfo } = entityInfoSlice.actions;

export const entityInfoSelectors = {
  selectEntityInfo: (state: RootState) => state.entityInfo?.entityInfo,
  selectFarmTimeZone: (state: RootState) =>
    state.entityInfo?.entityInfo?.farmTimeZone || DEFAULT_TIMEZONE,
  isFarmTimeZoneProvided: (state: RootState) =>
    !!state.entityInfo?.entityInfo?.farmTimeZone,
};

export default entityInfoSlice.reducer;
